var map = {
	"./Avatar1x.svg": [
		65904,
		5904
	],
	"./LogoLogged.svg": [
		71958,
		1958
	],
	"./LogoZap.svg": [
		61210,
		1210
	],
	"./accessibility.svg": [
		87338,
		7338
	],
	"./ad.svg": [
		80490,
		490
	],
	"./avatar-aqua.svg": [
		37627,
		7627
	],
	"./avatar-blue.svg": [
		37556,
		7556
	],
	"./avatar-brown.svg": [
		32731,
		2731
	],
	"./avatar-green.svg": [
		89451,
		9451
	],
	"./avatar-pink.svg": [
		50432,
		432
	],
	"./avatar-purple.svg": [
		1011,
		1011
	],
	"./avatar-red.svg": [
		20857,
		857
	],
	"./avatar-turquoise.svg": [
		6178,
		6178
	],
	"./avatar-yellow.svg": [
		98457,
		8457
	],
	"./avatar/avatar-aqua.svg": [
		66438,
		6438
	],
	"./avatar/avatar-blue.svg": [
		99789,
		9789
	],
	"./avatar/avatar-brown.svg": [
		29210,
		9210
	],
	"./avatar/avatar-green.svg": [
		62147,
		2147
	],
	"./avatar/avatar-pink.svg": [
		81833,
		1833
	],
	"./avatar/avatar-purple.svg": [
		36531,
		6531
	],
	"./avatar/avatar-red.svg": [
		7766,
		7766
	],
	"./avatar/avatar-turquoise.svg": [
		5384,
		5384
	],
	"./avatar/avatar-yellow.svg": [
		86879,
		6879
	],
	"./business-overview/facebook.svg": [
		40440,
		440
	],
	"./business-overview/instgram.svg": [
		77308,
		7308
	],
	"./business-overview/linkedin.svg": [
		17318,
		7318
	],
	"./business-overview/tiktok.svg": [
		91464,
		1464
	],
	"./business-overview/twitter.svg": [
		9576,
		9576
	],
	"./business.svg": [
		49356,
		9356
	],
	"./calls-management.svg": [
		46832,
		6832
	],
	"./cancel.svg": [
		48535,
		8535
	],
	"./chat.svg": [
		94416,
		4416
	],
	"./clock.svg": [
		9143,
		9143
	],
	"./contact.svg": [
		74180,
		4180
	],
	"./delivery2.svg": [
		37490,
		7490
	],
	"./doctors.svg": [
		65832,
		5832
	],
	"./edit-icon.svg": [
		44131,
		4131
	],
	"./edit.svg": [
		76937,
		6937
	],
	"./finger-print-disabling.svg": [
		40786,
		786
	],
	"./history-actions.svg": [
		7927,
		7927
	],
	"./home1.svg": [
		783,
		783
	],
	"./homepage-gray-calls.svg": [
		30621,
		621
	],
	"./homepage/ad.svg": [
		52105,
		2105
	],
	"./homepage/business_details.svg": [
		80774,
		774
	],
	"./homepage/cart.svg": [
		5023,
		5023
	],
	"./homepage/contact.svg": [
		6500,
		6500
	],
	"./homepage/delivery.svg": [
		57386,
		7386
	],
	"./homepage/disable_ad.svg": [
		42126,
		2126
	],
	"./homepage/disable_pricing.svg": [
		16762,
		6762
	],
	"./homepage/disable_review.svg": [
		34322,
		4322
	],
	"./homepage/disable_stat.svg": [
		13161,
		3161
	],
	"./homepage/edit_details.svg": [
		8168,
		8168
	],
	"./homepage/homepage-calls.svg": [
		88925,
		8925
	],
	"./homepage/homepage-clicks.svg": [
		78525,
		8525
	],
	"./homepage/homepage-eye.svg": [
		79740,
		9740
	],
	"./homepage/homepage-incoming-calls.svg": [
		22928,
		2928
	],
	"./homepage/homepage-lead.svg": [
		56274,
		6274
	],
	"./homepage/more.svg": [
		86205,
		6205
	],
	"./homepage/opening-hours.svg": [
		69600,
		9600
	],
	"./homepage/phone-call-svgrepo-com.svg": [
		87483,
		7483
	],
	"./homepage/pricing-icon.svg": [
		88354,
		8354
	],
	"./homepage/recipts.svg": [
		12252,
		2252
	],
	"./homepage/review.svg": [
		58379,
		8379
	],
	"./homepage/stat.svg": [
		91454,
		1454
	],
	"./linear-gradient-icons/business.svg": [
		85039,
		5039
	],
	"./linear-gradient-icons/delivery3.svg": [
		98678,
		8678
	],
	"./linear-gradient-icons/phone-call.svg": [
		76894,
		6894
	],
	"./linear-gradient-icons/review.svg": [
		27083,
		7083
	],
	"./linear-gradient-icons/stat.svg": [
		25493,
		5493
	],
	"./log-out.svg": [
		33274,
		3274
	],
	"./mail-blue.svg": [
		60979,
		979
	],
	"./mail-white.svg": [
		2832,
		2832
	],
	"./mail.svg": [
		36829,
		6829
	],
	"./manage_accounts.svg": [
		61968,
		1826
	],
	"./message.svg": [
		2525,
		2525
	],
	"./minus.svg": [
		33,
		33
	],
	"./notification.svg": [
		95105,
		5105
	],
	"./paper-w.svg": [
		36083,
		6083
	],
	"./phone-black.svg": [
		51522,
		1522
	],
	"./phone-call.svg": [
		52064,
		2064
	],
	"./price-list.svg": [
		78151,
		8151
	],
	"./price.svg": [
		29135,
		9135
	],
	"./question-1.svg": [
		58226,
		8226
	],
	"./recipts.svg": [
		61741,
		1741
	],
	"./review.svg": [
		48005,
		8005
	],
	"./sand-clock.svg": [
		62781,
		2781
	],
	"./settings.svg": [
		45812,
		5812
	],
	"./stat.svg": [
		21189,
		1189
	],
	"./take-it-youself.svg": [
		8261,
		369
	],
	"./trash.svg": [
		11149,
		1149
	],
	"./verticals/D.svg": [
		24865,
		4865
	],
	"./verticals/dNew.svg": [
		83569,
		3569
	],
	"./verticals/doctors.svg": [
		58588,
		8588
	],
	"./verticals/doctorsNew.svg": [
		52792,
		2792
	],
	"./verticals/mishpati.svg": [
		61411,
		1411
	],
	"./verticals/mishpatiNew.svg": [
		51065,
		1065
	],
	"./verticals/mitchatnim.svg": [
		52825,
		2825
	],
	"./verticals/mitchatnimNew.svg": [
		33692,
		3692
	],
	"./verticals/rest.svg": [
		63774,
		3774
	],
	"./verticals/restNew.svg": [
		83173,
		3173
	],
	"./verticals/zap group.svg": [
		51313,
		1313
	],
	"./verticals/zap.svg": [
		37990,
		7990
	],
	"./verticals/zapNew.svg": [
		29198,
		9198
	],
	"./wave-4.svg": [
		24529,
		4529
	],
	"./wave.svg": [
		53599,
		3599
	],
	"./whatsapp-social-media.svg": [
		62055,
		2055
	],
	"./whatsapp.svg": [
		44511,
		4511
	],
	"./zap-coupons.svg": [
		57302,
		7302
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 93466;
module.exports = webpackAsyncContext;